import React, { useEffect, useCallback } from 'react';
import { successNotificationBuilder, useNotification, errorNotificationBuilder, NotificationTypes } from '@css-xp/base';

export const useModalNotification = (closeModal: () => void, id: string) => {
  const { sendSuccessNotification, notificationSent, setNotificationSent, sendErrorNotification } = useNotification();

  const renderSuccessNotification = useCallback(
    (header: React.ReactNode, message: React.ReactNode) => {
      const notificationOptions = successNotificationBuilder()
        .withId(id)
        .withHeader(header)
        .withMessage(message)
        .withDismissAfter(3000)
        .isVersion(NotificationTypes.FLAG)
        .build();
      sendSuccessNotification(notificationOptions);
      setNotificationSent(true);
    },
    [closeModal]
  );

  const renderErrorNotification = useCallback(
    (header: React.ReactNode, message: React.ReactNode) => {
      const notificationOptions = errorNotificationBuilder()
        .withId(id)
        .withHeader(header)
        .withMessage(message)
        .withDismissAfter(3000)
        .isVersion(NotificationTypes.FLAG)
        .build();
      sendErrorNotification(notificationOptions);
      setNotificationSent(true);
    },
    [closeModal]
  );

  useEffect(() => {
    if (notificationSent) {
      closeModal();
    }
  }, [notificationSent]);

  return [renderSuccessNotification, renderErrorNotification];
};
